import { createTheme } from '@mui/material/styles';
import deepOrange from '@mui/material/colors/deepOrange';
import green from '@mui/material/colors/green';
import red from '@mui/material/colors/red';

const theme = createTheme({
    palette: {
        primary: {
            light: '#ffffff',
            main: '#b4b4c0',
            // dark: will be calculated from palette.primary.main,
            contrastText: '#ffffff',
        },
        secondary: deepOrange,
        success: green,
        danger: red
    }
});
export default theme;